var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWzeditorsvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "writer (2) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.999,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0443 4.88721C30.0443 5.25179 30.0443 5.61638 30.0443 5.98096C20.5651 5.98096 11.086 5.98096 1.60681 5.98096C1.59542 5.06922 1.60682 4.15776 1.64099 3.24658C1.85746 2.39209 2.39294 1.85661 3.24743 1.64014C11.6329 1.59456 20.0182 1.59456 28.4037 1.64014C29.2582 1.85661 29.7936 2.39209 30.0101 3.24658C30.0443 3.79299 30.0557 4.33986 30.0443 4.88721Z",
    fill: "#6A097D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34082 3.24658C4.7054 3.24658 5.06999 3.24658 5.43457 3.24658C5.43457 3.61116 5.43457 3.97575 5.43457 4.34033C5.06999 4.34033 4.7054 4.34033 4.34082 4.34033C4.34082 3.97575 4.34082 3.61116 4.34082 3.24658Z",
    fill: "#23A1F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.52832 3.24658C6.89288 3.24658 7.25751 3.24658 7.62207 3.24658C7.62207 3.61116 7.62207 3.97575 7.62207 4.34033C7.25751 4.34033 6.89288 4.34033 6.52832 4.34033C6.52832 3.97575 6.52832 3.61116 6.52832 3.24658Z",
    fill: "#42C98D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71582 3.24658C9.08038 3.24658 9.44501 3.24658 9.80957 3.24658C9.80957 3.61116 9.80957 3.97575 9.80957 4.34033C9.44501 4.34033 9.08038 4.34033 8.71582 4.34033C8.71582 3.97575 8.71582 3.61116 8.71582 3.24658Z",
    fill: "#F44555"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0439 4.88721C30.4085 4.88721 30.7731 4.88721 31.1377 4.88721C31.1377 6.34554 31.1377 7.8039 31.1377 9.26221C30.7731 9.26221 30.4085 9.26221 30.0439 9.26221C30.0439 8.16846 30.0439 7.07471 30.0439 5.98096C30.0439 5.61638 30.0439 5.25179 30.0439 4.88721Z",
    fill: "#6A097D",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.991,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1377 4.88726C31.9385 4.87179 32.5652 5.1908 33.0176 5.84429C33.1355 6.06126 33.2266 6.28912 33.291 6.52788C33.3252 7.43904 33.3366 8.35055 33.3252 9.26226C32.596 9.26226 31.8669 9.26226 31.1377 9.26226C31.1377 7.80395 31.1377 6.34559 31.1377 4.88726Z",
    fill: "#6A097D",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.60681 5.98096C11.086 5.98096 20.5651 5.98096 30.0443 5.98096C30.0443 7.07471 30.0443 8.16846 30.0443 9.26221C30.0443 10.2192 30.0443 11.1763 30.0443 12.1333C29.3151 12.8853 28.586 13.6372 27.8568 14.3892C25.3697 16.8079 22.9315 19.2689 20.5424 21.772C20.1947 22.4717 19.8984 23.2008 19.6537 23.9595C19.3061 24.8269 18.9644 25.7041 18.6283 26.5913C18.6511 26.6255 18.6739 26.6597 18.6967 26.6938C19.245 26.4879 19.7918 26.2828 20.3373 26.0786C20.0728 26.6676 19.8677 27.26 19.722 27.856C21.3789 27.2009 23.0423 26.5515 24.7123 25.9077C26.4782 24.1418 28.2442 22.3758 30.0101 20.6099C30.0557 23.1848 30.0557 25.7596 30.0101 28.3345C29.7933 29.1225 29.3034 29.6579 28.5404 29.9409C20.6584 30.0426 12.7742 30.0768 4.88806 30.0435C4.34072 30.0548 3.79384 30.0435 3.24744 30.0093C2.39295 29.7928 1.85747 29.2573 1.64099 28.4028C1.60681 20.9289 1.59542 13.455 1.60681 5.98096Z",
    fill: "#F1D9FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34082 9.26221C7.62207 9.26221 10.9033 9.26221 14.1846 9.26221C14.1846 11.0851 14.1846 12.908 14.1846 14.731C10.9033 14.731 7.62207 14.731 4.34082 14.731C4.34082 12.908 4.34082 11.0851 4.34082 9.26221Z",
    fill: "#AE71BE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3721 9.26221C16.7366 9.26221 17.1013 9.26221 17.4658 9.26221C17.4658 9.62677 17.4658 9.9914 17.4658 10.356C17.1013 10.356 16.7366 10.356 16.3721 10.356C16.3721 9.9914 16.3721 9.62677 16.3721 9.26221Z",
    fill: "#6A097D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5596 9.26221C21.4763 9.26221 24.3929 9.26221 27.3096 9.26221C27.3096 9.62677 27.3096 9.9914 27.3096 10.356C24.3929 10.356 21.4763 10.356 18.5596 10.356C18.5596 9.9914 18.5596 9.62677 18.5596 9.26221Z",
    fill: "#6A097D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0439 9.26221C30.4085 9.26221 30.7731 9.26221 31.1377 9.26221C31.1603 10.5046 31.1375 11.735 31.0693 12.9536C30.7528 12.6713 30.4451 12.3751 30.1465 12.0649C30.1203 12.1029 30.0861 12.1257 30.0439 12.1333C30.0439 11.1763 30.0439 10.2192 30.0439 9.26221Z",
    fill: "#CDAED3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1377 9.26221C31.8669 9.26221 32.596 9.26221 33.3252 9.26221C33.3252 11.2446 33.3252 13.2271 33.3252 15.2095C33.3024 15.2095 33.2796 15.2095 33.2568 15.2095C32.5276 14.4575 31.7985 13.7056 31.0693 12.9536C31.1375 11.735 31.1603 10.5046 31.1377 9.26221Z",
    fill: "#9831AD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3721 11.4497C19.6533 11.4497 22.9346 11.4497 26.2158 11.4497C26.2158 11.8143 26.2158 12.1789 26.2158 12.5435C22.9346 12.5435 19.6533 12.5435 16.3721 12.5435C16.3721 12.1789 16.3721 11.8143 16.3721 11.4497Z",
    fill: "#6A097D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0693 12.9536C31.7985 13.7056 32.5276 14.4575 33.2568 15.2095C32.5276 15.8931 31.8213 16.5994 31.1377 17.3286C31.0693 17.3742 31.001 17.4197 30.9326 17.4653C30.4085 16.9641 29.8845 16.4627 29.3604 15.9614C28.9085 15.3955 28.4071 14.8714 27.8564 14.3892C28.5856 13.6372 29.3148 12.8853 30.0439 12.1333C30.0861 12.1257 30.1203 12.1029 30.1465 12.0649C30.4451 12.3751 30.7528 12.6713 31.0693 12.9536Z",
    fill: "#6A097D",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3721 13.6372C18.9241 13.6372 21.4763 13.6372 24.0283 13.6372C24.0283 14.0018 24.0283 14.3664 24.0283 14.731C21.4763 14.731 18.9241 14.731 16.3721 14.731C16.3721 14.3664 16.3721 14.0018 16.3721 13.6372Z",
    fill: "#6A097D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8564 14.3892C28.4071 14.8714 28.9085 15.3955 29.3604 15.9614C26.936 18.3516 24.5206 20.7556 22.1143 23.1733C22.0737 23.2051 22.0281 23.2165 21.9775 23.2075C21.4763 22.7518 20.9977 22.2733 20.542 21.772C22.9312 19.2689 25.3693 16.8079 27.8564 14.3892Z",
    fill: "#FEB64C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2568 15.2095C33.2796 15.2095 33.3024 15.2095 33.3252 15.2095C33.3252 15.9158 33.3252 16.6223 33.3252 17.3286C32.596 18.035 31.8669 18.7414 31.1377 19.4478C31.1377 18.7414 31.1377 18.035 31.1377 17.3286C31.8213 16.5994 32.5276 15.8931 33.2568 15.2095Z",
    fill: "#9831AD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3604 15.9614C29.8845 16.4627 30.4085 16.9641 30.9326 17.4653C30.6364 17.7844 30.3401 18.1033 30.0439 18.4224C27.8792 20.5643 25.7145 22.7062 23.5498 24.8481C23.0257 24.3013 22.5017 23.7544 21.9775 23.2075C22.0281 23.2165 22.0737 23.2051 22.1143 23.1733C24.5206 20.7556 26.936 18.3516 29.3604 15.9614Z",
    fill: "#CD8923"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    opacity: 0.999,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3255 17.3286C33.337 22.1138 33.3255 26.899 33.2914 31.6841C33.0749 32.5386 32.5394 33.074 31.6849 33.2905C23.2995 33.3361 14.9141 33.3361 6.52867 33.2905C5.85807 33.1096 5.36816 32.7108 5.05894 32.0942C4.92397 31.7892 4.867 31.4702 4.88805 31.1372C13.0684 31.1486 21.2488 31.1372 29.4291 31.103C30.3063 30.8638 30.8646 30.3055 31.1039 29.4282C31.138 26.1243 31.1495 22.8202 31.138 19.5161C31.138 19.4933 31.138 19.4705 31.138 19.4478C31.8672 18.7414 32.5964 18.035 33.3255 17.3286Z",
    fill: "#9831AD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.138 17.3286C31.138 18.035 31.138 18.7414 31.138 19.4478C31.138 19.4705 31.138 19.4933 31.138 19.5161C30.7759 19.844 30.4227 20.1858 30.0785 20.5415C30.0443 19.8355 30.0329 19.1291 30.0443 18.4224C30.3405 18.1033 30.6368 17.7844 30.933 17.4653C31.0013 17.4197 31.0697 17.3742 31.138 17.3286Z",
    fill: "#CDAED3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34082 17.4653C4.7054 17.4653 5.06999 17.4653 5.43457 17.4653C5.43457 17.8299 5.43457 18.1945 5.43457 18.5591C5.06999 18.5591 4.7054 18.5591 4.34082 18.5591C4.34082 18.1945 4.34082 17.8299 4.34082 17.4653Z",
    fill: "#6A097D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.52832 17.4653C11.2679 17.4653 16.0075 17.4653 20.7471 17.4653C20.7471 17.8299 20.7471 18.1945 20.7471 18.5591C16.0075 18.5591 11.2679 18.5591 6.52832 18.5591C6.52832 18.1945 6.52832 17.8299 6.52832 17.4653Z",
    fill: "#6A097D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0439 18.4224C30.0326 19.1291 30.0439 19.8355 30.0781 20.5415C30.4223 20.1858 30.7755 19.844 31.1377 19.5161C31.1491 22.8202 31.1377 26.1243 31.1035 29.4282C30.8643 30.3055 30.306 30.8638 29.4287 31.103C21.2484 31.1372 13.0681 31.1486 4.8877 31.1372C4.8877 30.7726 4.8877 30.408 4.8877 30.0435C12.7738 30.0768 20.658 30.0426 28.54 29.9409C29.303 29.6579 29.7929 29.1225 30.0098 28.3345C30.0554 25.7596 30.0554 23.1848 30.0098 20.6099C28.2438 22.3758 26.4778 24.1418 24.7119 25.9077C23.042 26.5515 21.3786 27.2009 19.7217 27.856C19.8674 27.26 20.0724 26.6676 20.3369 26.0786C20.6664 25.954 20.9854 25.8173 21.2939 25.6685C22.0526 25.4145 22.8046 25.1411 23.5498 24.8481C25.7145 22.7062 27.8792 20.5643 30.0439 18.4224Z",
    fill: "#CDAED3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34082 19.6528C9.08038 19.6528 13.82 19.6528 18.5596 19.6528C18.5596 20.0174 18.5596 20.382 18.5596 20.7466C13.82 20.7466 9.08038 20.7466 4.34082 20.7466C4.34082 20.382 4.34082 20.0174 4.34082 19.6528Z",
    fill: "#6A097D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34082 21.8403C8.35126 21.8403 12.3616 21.8403 16.3721 21.8403C16.3721 22.2049 16.3721 22.5695 16.3721 22.9341C12.3616 22.9341 8.35126 22.9341 4.34082 22.9341C4.34082 22.5695 4.34082 22.2049 4.34082 21.8403Z",
    fill: "#6A097D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.542 21.772C20.9977 22.2733 21.4763 22.7518 21.9775 23.2075C22.5017 23.7544 23.0257 24.3013 23.5498 24.8481C22.8046 25.1411 22.0526 25.4145 21.2939 25.6685C20.7471 25.0988 20.2002 24.5291 19.6533 23.9595C19.898 23.2008 20.1943 22.4717 20.542 21.772Z",
    fill: "#D0D2D4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34082 24.0278C8.35126 24.0278 12.3616 24.0278 16.3721 24.0278C16.3721 24.3924 16.3721 24.757 16.3721 25.1216C12.3616 25.1216 8.35126 25.1216 4.34082 25.1216C4.34082 24.757 4.34082 24.3924 4.34082 24.0278Z",
    fill: "#6A097D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6533 23.9595C20.2002 24.5291 20.7471 25.0988 21.2939 25.6685C20.9854 25.8173 20.6664 25.954 20.3369 26.0786C19.7915 26.2828 19.2446 26.4879 18.6963 26.6938C18.6735 26.6597 18.6507 26.6255 18.6279 26.5913C18.964 25.7041 19.3058 24.8269 19.6533 23.9595Z",
    fill: "#130E14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34082 26.2153C8.35126 26.2153 12.3616 26.2153 16.3721 26.2153C16.3721 26.5799 16.3721 26.9445 16.3721 27.3091C12.3616 27.3091 8.35126 27.3091 4.34082 27.3091C4.34082 26.9445 4.34082 26.5799 4.34082 26.2153Z",
    fill: "#6A097D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWzeditorsvg);
export default __webpack_public_path__ + "static/media/Wzeditorsvg.8afa2730b38efd6af10d49f5f725d738.svg";
export { ForwardRef as ReactComponent };